import type {
  SupplierRelationshipCreateRequestType,
  SupplierRelationshipCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierRelationshipCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `supplier-relationships`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey;
          return (
            queryKey[0] === user?.uid &&
            queryKey[1] === business?.id &&
            queryKey[2] === ServerStateKeys.SupplierRelationships
          );
        },
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierRelationships,
          response.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Retailers],
      });
    },
  });
};
